<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
    </mat-card-header>

    <mat-card-content>
        <div id="heatmap-wrapper">
            <div id="basic_heatmap_chart"></div>
        </div>
    </mat-card-content>
</mat-card>